/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { IBarrierStatusSpecialStatus } from 'plugin-codaf-risk-ext-bowtie/types'
import {
    IResourceBarrierAnalysisGraph,
    IResourceBarrierAnalysisGraphic
} from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { NoInfo } from '../../styles'
import { GraphicContainer, GraphicField, GraphicPopover, Line, Timeline } from './style'

interface IProps {
    description?: IBarrierDataToGraph
    data?: IResourceBarrierAnalysisGraphic
    loading: boolean
    dictionaryStatusMap: Map<number, IBarrierStatusSpecialStatus>
}

interface IBarrierDataToGraph {
    barrierId: number
    barrierName: string
}

interface ITimeLine {
    start: number
    days: number
    end: number
}

export const ReportGraph: React.FC<IProps> = ({ description, data, loading, dictionaryStatusMap }) => {
    const [startTimeLine, setStartTimeLine] = useState<number>()
    const [endTimeLine, setEndTimeLine] = useState<number>()
    const [timeLineSize, setTimeLineSize] = useState<number[]>([])
    const [graphDays, setGraphDays] = useState<string[]>([])

    const dateConverter = (date: number): string => {
        const newDate = new Date(date)
        const converted = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${converted}`
    }

    const preparingEvents = (ev: IResourceBarrierAnalysisGraphic): IResourceBarrierAnalysisGraphic => {
        const constToRender = 500
        if (ev.reportEvent.length > constToRender) {
            const mainEvents = ev.reportEvent.sort((a, b) => {
                if (a.finalDate - a.initialDate > b.finalDate - b.initialDate) return -1
                if (a.finalDate - a.initialDate < b.finalDate - b.initialDate) return 1

                return 0
            })

            const arrayToDivideEvents: IResourceBarrierAnalysisGraph[] = []

            for (let i = 0; i < constToRender; i++) {
                arrayToDivideEvents.push(mainEvents[i])
            }

            arrayToDivideEvents.sort((a, b) => {
                if (a.date < b.date) return -1
                if (a.date > b.date) return 1

                return 0
            })

            const newDataGrath: IResourceBarrierAnalysisGraphic = {
                total: constToRender,
                reportEvent: arrayToDivideEvents
            }

            return newDataGrath
        } else {
            return ev
        }
    }

    const generateGraphicFieldSize = (graphField: IResourceBarrierAnalysisGraph): number => {
        if (data.total === 1) {
            return 100
        } else {
            let totalTime = 0

            for (let i = 0; i < data.total; i++) {
                totalTime = totalTime + (data.reportEvent[i].finalDate - data.reportEvent[i].date)
            }

            const onePercentGraph = totalTime / 100
            const fieldPercent = (graphField.finalDate - graphField.date) / onePercentGraph

            return fieldPercent
        }
    }

    const calcITotalTime = (ts): string => {
        const timeRemain = ts
        const second = 1000
        const minute = second * 60
        const hour = minute * 60
        const hours = timeRemain / hour
        const minutes = (timeRemain % hour) / minute
        const seconds = ((timeRemain % hour) % minute) / second

        return `${Math.floor(hours)}h ${minutes < 10 ? `0${Math.floor(minutes)}` : Math.floor(minutes)}m ${
            seconds < 10 ? `0${Math.floor(seconds)}` : Math.floor(seconds)
        }s`
    }

    const generateDays = (start, end): number[] => {
        const ts = end - start
        const second = 1000
        const minute = second * 60
        const hour = minute * 60
        const day = hour * 24
        const days = ts / day

        const startHours = new Date(start).getHours()
        const startMinutes = new Date(start).getMinutes()
        const startSeconds = new Date(start).getSeconds()
        const calcStart = startHours * hour + startMinutes * minute + startSeconds * second

        const endHours = new Date(end).getHours()
        const endMinutes = new Date(end).getMinutes()
        const endSeconds = new Date(end).getSeconds()
        const calcEnd = endHours * hour + endMinutes * minute + endSeconds * second

        const timeLine: ITimeLine = {
            start: calcStart,
            days: days < 3 ? Math.floor(days) : Math.floor(days - 1),
            end: calcEnd
        }

        const graphTimeline = []

        graphTimeline.push(timeLine.start)

        for (let i = 0; i < timeLine.days; i++) {
            graphTimeline.push(day)
        }

        graphTimeline.push(timeLine.end)

        return graphTimeline
    }

    const handleDays = (start, end): string[] => {
        const ts = end - start
        const second = 1000
        const minute = second * 60
        const hour = minute * 60
        const day = hour * 24
        const days = ts / day

        const timeLine = Math.floor(days)

        const graphTimeline = []

        for (let i = 0; i < timeLine; i++) {
            graphTimeline.push(day)
        }

        const getTimeStampTotal = []
        let totalTimeStamp = start

        for (let i = 0; i < graphTimeline.length; i++) {
            totalTimeStamp = graphTimeline[i] + totalTimeStamp
            getTimeStampTotal.push(totalTimeStamp)
        }

        const getDays = []

        for (let i = 0; i < getTimeStampTotal.length; i++) {
            const date = new Date(getTimeStampTotal[i])
            getDays.push(moment(date).format('DD MMM'))
        }

        return getDays
    }

    const calcTimeLineField = (arrayDays: number[]): number[] => {
        let total = 0
        for (let i = 0; i < arrayDays.length; i++) {
            total = total + arrayDays[i]
        }

        const onePercentGraph = total / 100
        const fieldWithPercent = []
        for (let i = 0; i < arrayDays.length; i++) {
            fieldWithPercent.push(arrayDays[i] / onePercentGraph)
        }

        return fieldWithPercent
    }

    const renderTimeLine = (): JSX.Element[] => {
        if (timeLineSize) {
            const renderObject = timeLineSize.map((field, index) => {
                return (
                    <Timeline key={index} className={'GraphField'} fieldSize={field} first={index === 0 && true}>
                        <div className="absoluteLine" />
                        <span>{graphDays.length > 31 ? '' : graphDays[index - 1]}</span>
                    </Timeline>
                )
            })

            return renderObject
        }
    }

    useEffect(() => {
        if (data && description.barrierId !== 0) {
            const eventsToRenderInGraphic: IResourceBarrierAnalysisGraphic = preparingEvents(data)
            setStartTimeLine(eventsToRenderInGraphic.reportEvent[0].date)
            setEndTimeLine(eventsToRenderInGraphic.reportEvent[eventsToRenderInGraphic.total - 1].finalDate)
        }
    }, [data])

    useEffect(() => {
        if (startTimeLine && endTimeLine) {
            setTimeLineSize(calcTimeLineField(generateDays(startTimeLine, endTimeLine)))
            setGraphDays(handleDays(startTimeLine, endTimeLine))
        }
    }, [startTimeLine, endTimeLine])

    const renderGraphField = (): JSX.Element[] => {
        const field = preparingEvents(data).reportEvent.map((graph, index) => {
            const popoverHoverFocus = (
                <Popover positionTop={50} id="popover-trigger-hover-focus">
                    <GraphicPopover>
                        <div className="timeInfoPopover">
                            <span>
                                <strong>
                                    {i18n('START')}: {dateConverter(graph.date)}
                                </strong>
                            </span>
                            <span>
                                <strong>
                                    {i18n('END')}: {dateConverter(graph.finalDate)}
                                </strong>
                            </span>
                            <span>
                                {i18n('Time Interval')}: {calcITotalTime(graph.finalDate - graph.date)}
                            </span>
                        </div>
                        <div className="timePopover">
                            <div
                                className={'iconStatus ' + graph.status}
                                style={{ background: graph.statusColor }}
                            ></div>
                            <span>{graph.status} </span>
                        </div>
                    </GraphicPopover>
                </Popover>
            )

            return (
                <OverlayTrigger key={index} trigger={['hover', 'focus']} placement="top" overlay={popoverHoverFocus}>
                    <GraphicField
                        key={index}
                        className={graph.status}
                        fieldSize={generateGraphicFieldSize(graph)}
                        color={graph.statusColor ?? '#606A80'}
                        style={{ background: graph.statusColor }}
                    >
                        <div className={`graph-color ${graph.status}`}></div>
                    </GraphicField>
                </OverlayTrigger>
            )
        })

        return field
    }

    return (
        <GraphicContainer>
            <div className="title">
                <span>{i18n('Graphic')}</span>
            </div>
            {data && description.barrierId !== 0 ? (
                loading ? (
                    <NoInfo>
                        <i className="fa fa-spinner fa-spin" />
                    </NoInfo>
                ) : (
                    <div className="GraphContainer">
                        <div className="description">
                            <span>
                                {description.barrierId} | {description.barrierName}
                            </span>
                        </div>
                        <div className="timelineGraph">{renderTimeLine()}</div>
                        <div className="graph">{renderGraphField()}</div>
                        <Line />
                    </div>
                )
            ) : (
                <div className="GraphContainerNoInfo">
                    <span>{i18n('Select an item from the list to view the graphic')}</span>
                </div>
            )}
        </GraphicContainer>
    )
}
